import { useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import { InlineSpinner } from "components/base/Spinner";
import { useModals } from "ModalProvider";
import { OdooContext } from "OdooProvider";
import { useContext } from "react";
import CreateIncOdooPoView from "./CreateIncOdooPoView";
import CreateIncOdooSoView from "./CreateIncOdooSoView";
import { FETCH_PLAN_FOR_INC_ODOO } from "./graphql";
import SyncPlanToPoView from "./SyncPlanToPoView";
import SyncPlanToSoView from "./SyncPlanToSoView";

const IncOdooOrdersView = ({ planId }) => {
  const { odooUrlInc } = useContext(OdooContext);
  const { loading, error, data } = useQuery(FETCH_PLAN_FOR_INC_ODOO, {
    variables: { planId },
    fetchPolicy: "network-only",
  });
  const modal = useModals();

  if (loading)
    return (
      <div className="relative">
        <InlineSpinner size={18} />
      </div>
    );

  if (error)
    return (
      <div className="relative">
        <Errors error={error} />
      </div>
    );

  const originalPlan = data.productionPlan;
  const extraData = JSON.parse(originalPlan.extraData || "{}");
  const odooData = JSON.parse(data.osPlanOdooData || "{}");

  console.log("odooData", odooData);

  function createOdooSO() {
    modal.present({
      title: "Create Odoo SO",
      maxWidth: "max-w-6xl",
      children: (
        <CreateIncOdooSoView
          planId={planId}
          extraData={extraData}
          hide={modal.hide}
        />
      ),
    });
  }

  function syncPlanToSo() {
    modal.present({
      title: "Sync Plan to INC Odoo SO",
      maxWidth: "max-w-6xl",
      children: (
        <SyncPlanToSoView
          planId={planId}
          soId={originalPlan.odooIncSo.objectId}
          hide={modal.hide}
        />
      ),
    });
  }

  function syncPlanToPo() {
    modal.present({
      title: "Sync Plan to INC Odoo PO",
      maxWidth: "max-w-6xl",
      children: (
        <SyncPlanToPoView
          planId={planId}
          poId={originalPlan.odooIncPo.objectId}
          hide={modal.hide}
        />
      ),
    });
  }

  function createOdooPO() {
    modal.present({
      title: "Create Odoo PO",
      maxWidth: "max-w-6xl",
      subtitle: "Create PO in INC Odoo for this plan",
      children: <CreateIncOdooPoView planId={planId} hide={modal.hide} />,
    });
  }

  return (
    <div className="space-y-2">
      {originalPlan.planType === "INC_FOB_ORDER" && (
        <>
          {originalPlan.odooIncSo ? (
            <div className="space-x-3 flex">
              <div>
                <a
                  className="text-purple-600"
                  href={`${odooUrlInc}/odoo/sales/${originalPlan.odooIncSo.objectId}`}
                  target="_blank"
                >
                  {originalPlan.odooIncSo.objectName}
                </a>
              </div>
              <Button onClick={syncPlanToSo}>Sync SO</Button>
            </div>
          ) : (
            <div className="space-y-1">
              {!extraData.fobCustomer && (
                <div className=" opacity-70 text-red-600 font-semibold">
                  Choose FOB Customer and save before creating SO for Odoo.
                </div>
              )}
              <Button onClick={createOdooSO} disabled={!extraData.fobCustomer}>
                Create SO for FOB Customer
              </Button>
            </div>
          )}
        </>
      )}

      <>
        {originalPlan.odooIncPo ? (
          <div className="space-y-1">
            <div className="space-x-3 flex">
              <div>
                <a
                  className="text-purple-600"
                  href={`${odooUrlInc}/odoo/purchase/${originalPlan.odooIncPo.objectId}`}
                  target="_blank"
                >
                  {originalPlan.odooIncPo.objectName}
                  {odooData.odoo_inc_po
                    ? ` (${odooData.odoo_inc_po.state})`
                    : null}
                </a>
              </div>

              {odooData.odoo_inc_po &&
                odooData.odoo_inc_po.state !== "cancel" && (
                  <Button onClick={syncPlanToPo}>Sync PO</Button>
                )}
            </div>

            {(!odooData.odoo_inc_po ||
              odooData.odoo_inc_po.state === "cancel") && (
              <div>
                <div className="text-red-600 dark:text-red-700">
                  The linked INC Odoo PO is not found or cancelled, you can
                  create a new PO for Waboba AB.
                </div>
                <Button className="mt-1" onClick={createOdooPO}>
                  Create PO for Waboba AB
                </Button>
              </div>
            )}
          </div>
        ) : (
          <Button onClick={createOdooPO}>Create PO for Waboba AB</Button>
        )}
      </>
    </div>
  );
};

export default IncOdooOrdersView;
